import * as React from "react";

// Only for TypeScript compilation purposes
// eslint-disable-next-line
declare var adsbygoogle: any;

export interface AdProps {
    sidebar?: boolean;
}

export class Ad extends React.Component<AdProps> {
    componentDidMount(): void {
        (adsbygoogle = (window as any).adsbygoogle || []).push({});
    }

    render() {
        const {sidebar = false} = this.props;

        if (sidebar) {
            return <ins className="adsbygoogle sidebar-ad"
                        data-ad-client="ca-pub-8015359566478847"
                        data-ad-slot="8793042103"/>
        } else {
            return <ins className="adsbygoogle"
                        style={{display: 'block'}}
                        data-ad-client="ca-pub-8015359566478847"
                        data-ad-slot="8793042103"
                        data-ad-format="auto"
                        data-full-width-responsive="true"/>
        }
    }
}